import { variables } from '@models/system-variables/variables';

const companyVars = {
	'Business Name': variables.companyName,
	'Business Phone': variables.companyPhone,
	'Business Email': variables.companyEmail,
	'Business Address': variables.companyAddress
};

const paymentVars = {
	'Payment Due Date': variables.invoiceDueDate,
	'Payment Amount': variables.invoiceAmount
};

const clientVars = {
	'Client First Name': variables.clientName,
	'Client Last Name': variables.clientSurname,
	'Client Company Name': variables.clientCompanyName,
	'Client Phone': variables.clientPhone,
	'Client Email': variables.clientEmail,
	'Client Address': variables.clientAddress,
	'Client Notes': variables.clientNotes
};

const secondaryClientVars = {
	'Secondary Client First Name': variables.secondaryClientFirstName,
	'Secondary Client Last Name': variables.secondaryClientLastName
};

const jobVars = {
	'Lead/Job Name': variables.jobName,
	'Lead/Job Date': variables.jobDate,
	'Lead/Job Start Time': variables.jobStartTime,
	'Lead/Job End Time': variables.jobEndTime,
	'Lead/Job Location': variables.jobLocation,
	'Lead/Job Type': variables.jobType,
	'Lead/Job Lead Source': variables.jobLeadSource,
	'Lead/Job Notes': variables.jobNotes
};

const appointmentVars = {
	'Upcoming Appointment Date': variables.upcomingAppointmentDate,
	'Upcoming Appointment Start Time': variables.upcomingAppointmentStartTime,
	'Upcoming Appointment End Time': variables.upcomingAppointmentEndTime,
	'Upcoming Appointment Location': variables.upcomingAppointmentLocation
};

const extraShootVars = {
	'Upcoming Extra Shoot Date': variables.upcomingExtraShootDate,
	'Upcoming Extra Shoot Start Time': variables.upcomingExtraShootStartTime,
	'Upcoming Extra Shoot End Time': variables.upcomingExtraShootEndTime,
	'Upcoming Extra Shoot Location': variables.upcomingExtraShootLocation
};

const invoiceJobVars = {
	'Total Invoice Amount': variables.totalInvoiceAmount
};

const linkVars = {
	'Invoice Link': variables.invoiceLink,
	'Quote Link': variables.quoteLink,
	'Contract Link': variables.contractLink,
	'Questionnaire Link': variables.questionnaireLink,
	'Gallery Link': variables.galleriesLink
};

const invoiceReminderVars = {
	'Appointment Date': variables.appointmentDate,
	'Appointment Start Time': variables.appointmentStartTime,
	'Appointment End Time': variables.appointmentEndTime,
	'Appointment Location': variables.appointmentLocation
};

export {
	companyVars,
	paymentVars,
	clientVars,
	secondaryClientVars,
	jobVars,
	appointmentVars,
	extraShootVars,
	invoiceJobVars,
	linkVars,
	invoiceReminderVars
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/models/system-variables/variable-groups.ts